<script>
import Base from "@/components/RequestDetails/FundCalc.vue";

export default {
  name: "DefaultViewFundCalc",
  extends: Base,
};
</script>

